import createIcon from '../../createIcon';

/**
 * @component @name Satellite
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgM0g1QzMuOSAzIDMgMy45IDMgNVYxOUMzIDIwLjEgMy45IDIxIDUgMjFIMTlDMjAuMSAyMSAyMSAyMC4xIDIxIDE5VjVDMjEgMy45IDIwLjEgMyAxOSAzWk01IDQuOTlIOEM4IDYuNjUgNi42NiA4IDUgOFY0Ljk5Wk01IDEyVjEwQzcuNzYgMTAgMTAgNy43NSAxMCA0Ljk5SDEyQzEyIDguODYgOC44NyAxMiA1IDEyWk01IDE4TDguNSAxMy41TDExIDE2LjUxTDE0LjUgMTJMMTkgMThINVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Satellite = createIcon('Satellite', [
  [
    'path',
    {
      d: 'M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM5 4.99H8C8 6.65 6.66 8 5 8V4.99ZM5 12V10C7.76 10 10 7.75 10 4.99H12C12 8.86 8.87 12 5 12ZM5 18L8.5 13.5L11 16.51L14.5 12L19 18H5Z',
      key: '1dvs55',
    },
  ],
]);

export default Satellite;
